// extracted by mini-css-extract-plugin
export var actions = "_u6-4";
export var item = "_u6-1";
export var price = "_u6-3";
export var quantity = "_u6-2";
export var table = "_u6-0";